import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Glassmorphism card container. Applies the standard glass visual (bg, blur,
 * border, shadow) to the host element — layout, padding, and border-radius must
 * be provided via classes on the host.
 *
 * @example
 * <om-glass-card class="flex flex-col gap-4 p-5 rounded-[20px] overflow-hidden">
 *   ...
 * </om-glass-card>
 *
 * <om-glass-card class="flex items-center p-4 rounded-2xl" [hoverable]="true">
 *   ...
 * </om-glass-card>
 */
@Component({
  selector: 'om-glass-card',
  imports: [],
  template: `<ng-content />`,
  styleUrl: './glass-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.hoverable]': 'hoverable() || null',
  },
})
export class GlassCard {
  hoverable = input<boolean>(false);
}
